<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    isPrimaryButtonHidden="true" (closeButtonActionEmt)="closeModal()" secondaryButtonLabel="Close"
    [modalHelpIndex]="modalHelpIndex">
    <div class="grid-container">
        <res-generic-grid gridName="Live Log" [automationId]="modalAutomationId" [(isBusy)]="isBusy" 
            [(isBusyMessage)]="isBusyMessage" [gridContext]="gridContext" [gridPagerCustomCallback]="gridPagerCustomCallback"
            [columnDefs]="columnDefs" [requestInfo]="requestInfo" [headerTemplate]="headerTemplate"
            [isRefreshIconHidden]="true" [pagerTemplate]="pagerTemplate" [responseCallback]="responseCallback">
        </res-generic-grid>
    </div>
    <ng-template #headerTemplate>      
        <div class='parent-header'>  
            <span>Include:</span>      
            <res-custom-checkbox content="Info" [automationId]="automationId + '-option-info'"
                [(ngModel)]="checkboxSelected.INFO" [isToggleBox]="true"
                (ngModelChange)="filterLogsAndLoad()"></res-custom-checkbox>
            <res-custom-checkbox content="Warning" [automationId]="automationId + '-option-warning'"
                [(ngModel)]="checkboxSelected.WARN" [isToggleBox]="true"
                (ngModelChange)="filterLogsAndLoad()"></res-custom-checkbox>
            <res-custom-checkbox content="Error" [automationId]="automationId + '-option-error'"
                [(ngModel)]="checkboxSelected.ERROR" [isToggleBox]="true"
                (ngModelChange)="filterLogsAndLoad()"></res-custom-checkbox>        
        </div>
    </ng-template>
    <ng-template #pagerTemplate>
        <button class="pager-button" (click)="loadMore()" [attr.data-automation-id]="automationId + '-refresh-button'">
            <i class="fa fa-plus"></i><span>Load Next 1000 Lines</span>
        </button>
        <button class="pager-button" (click)="loadData()" [attr.data-automation-id]="automationId + '-refresh-button'"
            [attr.title]="'Refresh'">
            <i class="fa fa-refresh"></i>
        </button>
        <button class="pager-button" (click)="downloadLogList()"
            [attr.data-automation-id]="automationId + '-download-report-button'" [attr.title]="'Download Log Entries ...'">
            <i class="fa fa-download"></i>
        </button>
    </ng-template>
    <a download #downloadLink hidden target="_blank"></a>
</res-base-modal>